import { useBoxWidth, signalWord } from "./srUtil";

const jitter = (s) => { let h = 0; for (const c of s) h = (h * 31 + c.charCodeAt(0)) % 997; return (h / 997 - 0.5) * 14; };

// x = price move since funds bought (rank among peers), y = signal strength; same sector, size and quarter.
export const PeerMap = ({ peers, symbol, onSelect }) => {
  const [ref, w] = useBoxWidth(470);
  const W = Math.max(300, w), H = W < 500 ? 290 : 330, X0 = 66, X1 = W - 24, bot = H - 75;
  const px = (v) => X0 + v * (X1 - X0), py = (v) => bot - ((v - 1) / 9) * (bot - 60);
  const me = peers.find((p) => p.symbol === symbol);
  const others = peers.filter((p) => p.symbol !== symbol && p.bp_pct != null && p.score_decile);
  const dot = (p, mine) => {
    const cx = px(p.bp_pct), cy = py(p.score_decile) + (mine ? 0 : jitter(p.symbol)), flip = cx + 60 > W;
    const act = () => onSelect(p);
    return (
      <g key={p.symbol} role="button" tabIndex={0} className="peerdot" aria-label={`Inspect ${p.symbol}`} onClick={act}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); act(); } }}
        data-testid={mine ? "sr-peer-self" : `sr-peer-${p.symbol}`}>
        <title>{`${p.symbol} · ${signalWord(p.score_decile)} signal`}</title>
        <circle cx={cx} cy={cy} r={mine ? 9 : 5.5} fill={mine ? "#34d399" : "#6b829b"} opacity={mine ? 1 : 0.75}
          stroke={mine ? "#d9fff0" : "#10141b"} strokeWidth="2" />
        {mine && <text x={flip ? cx - 14 : cx + 14} y={cy + 4} textAnchor={flip ? "end" : "start"} fill="#34d399" fontSize="13" fontWeight="600" stroke="#10141b" strokeWidth="4" paintOrder="stroke">{p.symbol}</text>}
      </g>
    );
  };
  return (
    <div ref={ref} style={{ marginTop: 18 }}>
      <svg viewBox={`0 0 ${W} ${H}`} role="img" data-testid="sr-peer-map" aria-label="Similar stocks by signal strength and price move since funds bought">
        <text x={X0} y="21" fill="#a0aab8" fontSize="12">Stronger signal ↑</text>
        {[[1, "Weak"], [5.5, "Average"], [10, "Strong"]].map(([v, l]) => (
          <g key={v}><line x1={X0} x2={X1} y1={py(v)} y2={py(v)} stroke="#26303b" />
            <text x={X0 - 10} y={py(v) + 4} textAnchor="end" fill="#a0aab8" fontSize="11">{l}</text></g>
        ))}
        <line x1={px(0.5)} x2={px(0.5)} y1="50" y2={bot + 7} stroke="#586879" strokeDasharray="4 5" />
        <text x={px(0)} y={bot + 25} textAnchor="start" fill="#a0aab8" fontSize="11">Less</text>
        <text x={px(1)} y={bot + 25} textAnchor="end" fill="#a0aab8" fontSize="11">More</text>
        <text x={(X0 + X1) / 2} y={H - 14} textAnchor="middle" fill="#a0aab8" fontSize="12">Price rise since funds bought →</text>
        {others.map((p) => dot(p, false))}
        {me && me.bp_pct != null && dot(me, true)}
      </svg>
    </div>
  );
};
